module.exports = __webpack_public_path__ + "img/icon-login-logo@2x.878d893a.png";